import { getIntlText, getLocaleCache, getText } from '@/lib/i18n/i18n.server';

const instatusLanguages = [
  'ar',
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'id',
  'it',
  'nl',
  'no',
  'pl',
  'pt-BR',
  'pt',
  'rs',
  'ru',
  'ro',
  'sl',
  'tr',
  'uk',
  'vi',
  'zh-TW',
  'zh',
  'sv',
  'ja',
  'ko',
  'sq',
  'hu',
  'et',
] as const;
type InstatusLanguage = (typeof instatusLanguages)[number];

export type ReducedInstatusComponent = {
  status: string;
  name: string;
  translations: { name: { [key in InstatusLanguage]: string } };
};

export const OK_STATUS = 'OPERATIONAL' as const;

export const getMessageForDownServices = (
  components: Array<{
    status: string;
    translations: { name: { [key in InstatusLanguage]?: string } };
  }>,
  texts: Awaited<ReturnType<typeof getText>>
) => {
  const text = texts;

  const downServices = components.filter((item) => item.status !== OK_STATUS);

  let instatusLang: InstatusLanguage = 'en';
  const localeCache = getLocaleCache();

  if (!localeCache) instatusLang = 'en';
  else if (localeCache === 'zh-cn') instatusLang = 'zh';
  else instatusLang = localeCache as InstatusLanguage;

  const isAllUp = downServices.length === 0;
  const isOneDown = downServices.length === 1;
  const areMultipleDown = downServices.length > 1;
  const downServiceName =
    downServices?.[0]?.translations.name[instatusLang] || '';

  let message = text.service_status.loading;
  let status: 'success' | 'error' | 'loading' = 'loading';

  if (components.length === 0) return { message, status };

  if (isAllUp) {
    message = getIntlText(text.service_status.all_services_operational);
    status = 'success';
  } else if (isOneDown) {
    message = getIntlText(text.service_status.single_service_disruption, {
      name: downServiceName,
    });
    status = 'error';
  } else if (areMultipleDown) {
    message = getIntlText(text.service_status.multiple_service_disruption, {
      number_of_services: String(downServices.length),
    });
    status = 'error';
  }

  return { message, status };
};
